<template>
	<div class="hotel-facilities-teaser">
		<div class="hotel-facilities-teaser__list">
			<InfoIconHeader
				v-for="facility in mergedFacilities"
				:key="facility.Name"
				class="hotel-facilities-teaser__list-item"
				:icon="facility.icon"
				:title="facility.Name"
				size="small"
			/>
		</div>
		<BaseModal
			:header-title="modalTitle"
			class="hotel-facilities-teaser__modal"
			with-open-button
			:open-button-props="{ label: buttonLabel, class: 'hotel-facilities-teaser__show-more' }"
			@open="onShowMoreClick"
		>
			<HotelFacilitiesGrid :attributes />
		</BaseModal>
	</div>
</template>
<script setup lang="ts">
import InfoIconHeader from '@lmt-rpb/Molecules/HotelFacilitiesTeaser/internals/IconInfoHeader.vue';
import { computed } from 'vue';
import BaseModal from '@lmt-rpb/BaseModal/BaseModal.vue';
import type { IconNames } from '@lmt-rpb/BaseIcon/svg';
import type { Attribute } from '@/interfaces/offer-list-types/offer-list-typo-hotel-data';
import { getHotelFacilityIcon } from './helpers';
import HotelFacilitiesGrid from './internals/HotelFacilitiesGrid.vue';

interface Props {
	attributes: Attribute[];
	topSeller?: boolean;
	rooms?: number;
	buttonLabel?: string;
	modalTitle?: string;
}

const props = withDefaults(defineProps<Props>(), {
	topSeller: false,
	rooms: undefined,
	buttonLabel: 'Komplette Ausstattung',
	modalTitle: 'Ausstattung',
});

const emit = defineEmits(['show-more-click']);

const mergedFacilities = computed(() => {
	const _mergedFacilities: { Name: string; icon: IconNames }[] = [];
	if (props.topSeller) {
		_mergedFacilities.push({ Name: 'Top Seller', icon: 'topSeller' });
	}
	if (props.rooms) {
		_mergedFacilities.push({ Name: `${props.rooms} Zimmer`, icon: 'rooms' });
	}
	return [
		..._mergedFacilities,
		...props.attributes.map((attribute) => ({ Name: attribute.Attributes[0].Name, icon: getHotelFacilityIcon(attribute.Name) })),
	];
});

const onShowMoreClick = () => {
	emit('show-more-click');
};
</script>

<style lang="scss" scoped>
.hotel-facilities-teaser {
	text-align: left;
	width: 100%;

	&__list {
		display: flex;
		flex-wrap: wrap;
		gap: 1.6rem;
		margin-bottom: 1.6rem;
	}

	@media screen and (min-width: $breakpoint-large) {
		&__list {
			gap: 1.6rem 2.4rem;
		}
	}
}
</style>
